import React, { useEffect } from 'react';
export function FirstSlide() {
  return <div className="w-full bg-[#cbcfce]" data-id="element-20">
      {/* Mobile: Image first, then text */}
      <div className="md:hidden" data-id="element-21">
        {/* Mobile: Full bleed landscape image at top */}
        <div className="w-full flex justify-center items-center" data-id="element-22">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cPQBhVve2vR1ispjp5fx5u/Edited-20250404_MM_Motherhood_SHOT_37_034_CTX_PR.jpg" alt="The Fourth Magazine - Shoes and Pacifier" className="w-full h-auto object-contain" data-id="element-23" />
        </div>

        {/* Mobile: Title below image */}
        <div className="px-6 pt-8 pb-4" data-id="element-24">
          <div className="flex items-baseline" data-id="element-25">
            <span style={{
            fontFamily: 'Georgia, serif',
            fontSize: '16px'
          }} data-id="element-26">
              the
            </span>
            <span style={{
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: '60px',
            fontWeight: '400',
            lineHeight: '0.85',
            margin: '0 2px'
          }} data-id="element-27">
              4
            </span>
            <span style={{
            fontFamily: 'Georgia, serif',
            fontSize: '16px'
          }} data-id="element-28">
              th magazine
            </span>
          </div>
        </div>

        {/* Mobile: Tagline */}
        <div className="px-6 pb-6" data-id="element-29">
          <div style={{
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontSize: '18px',
          fontWeight: '700'
        }} data-id="element-30">
            redefining contemporary motherhood
          </div>
        </div>
      </div>

      {/* Desktop: min-h-screen with flex layout */}
      <div className="hidden md:flex md:min-h-screen md:flex-col" data-id="element-31">
        {/* Desktop: Original image at top */}
        <div className="flex justify-center" data-id="element-32">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cPQBhVve2vR1ispjp5fx5u/Edited-20250404_MM_Motherhood_SHOT_37_034_CTX_PR.jpg" alt="The Fourth Magazine - Shoes and Pacifier" className="w-auto h-auto object-contain" style={{
          maxWidth: '90%',
          maxHeight: '70vh'
        }} data-id="element-33" />
        </div>

        {/* Desktop: Spacer to push text to bottom */}
        <div className="flex-1" data-id="element-34"></div>

        {/* Desktop: Bottom text section */}
        <div className="flex justify-between items-end px-12 pb-8" data-id="element-35">
          {/* Left: "the 4th magazine" */}
          <div className="flex items-baseline" data-id="element-36">
            <span style={{
            fontFamily: 'Georgia, serif',
            fontSize: '20px'
          }} data-id="element-37">
              the
            </span>
            <span style={{
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: '100px',
            fontWeight: '400',
            lineHeight: '0.85',
            margin: '0 2px'
          }} data-id="element-38">
              4
            </span>
            <span style={{
            fontFamily: 'Georgia, serif',
            fontSize: '20px'
          }} data-id="element-39">
              th magazine
            </span>
          </div>

          {/* Right: "redefining contemporary motherhood" */}
          <div style={{
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontSize: '20px',
          fontWeight: '700'
        }} data-id="element-40">
            redefining contemporary motherhood
          </div>
        </div>
      </div>
    </div>;
}